import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import employeesActions from '../../../Actions/Von/employeesActions';
import commonActions from "../../../Actions/commonActions";
import customerActions from '../../../Actions/customerActions';
import formActions from "../../../Actions/formActions";
import { VonEmployeeTypes, VonEmployeeTypesText } from "../../../Constants/VON/EmployeeForm/vonEmployeeTypes";
import * as formValidationRules from "../../../Constants/formValidationRules";
import forms from "../../../Constants/forms";
import useFormValidation from "../../../Hooks/Form/useFormValidation";
import useModal from "../../../Hooks/useModal";
import { Dropdown } from "../../FormComponents/Dropdown";
import DateTimeInput from "../../FormComponents/Input/DateTimeInput";
import { FormInput } from "../../FormComponents/Input/Input";
import { Button, ButtonOption } from "../../Fundamentals/Button";
import { ModalSize } from "../../Fundamentals/Modal/StandardModal";
import { StepperModal } from "../../Fundamentals/Modal/StepperModal";
import { StandardStepFooter, Step, StepBody, StepHeaderType } from "../../Fundamentals/Stepper/Step";

const CreateVonEmployeeModal = ({ }) => {
    const dispatch = useDispatch();
    const form = useSelector(state => state.FormReducer.forms[forms.vonNewEmployeeForm]);

    useEffect(() => {
        dispatch(formActions.startFormEditing(forms.vonNewEmployeeForm, { email: "" }, formValidationRules.VonEmployeeCheckForm));

        return () => {
            dispatch(commonActions.cancelFormEditing(forms.vonNewEmployeeForm));
        }
    }, [dispatch]);

    if (!form) return null;

    return <CreateVonEmployeeModalForm form={form} />;
}

const CreateVonEmployeeModalForm = ({ form }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const stepLoading = useSelector(state => state.CommonReducer.dataLoading['checkVonUser']);
    const customer = useSelector(state => state.CustomerReducer.customer);
    const { field } = useFormValidation(form);
    const { closeModal } = useModal();

    const onSubmit = () => {
        const customerId = customer.vonCustomer?.id ?? customer.vossCustomer.id;
        dispatch(employeesActions.addVonEmployee(form, customerId, () => {
            closeModal();
            dispatch(customerActions.getVonAccounts(customerId));
            dispatch(customerActions.searchSubscriptions(customerId));
        }));
    };

    const employeeTypes = [
        { id: VonEmployeeTypes.User, name: t(VonEmployeeTypesText[VonEmployeeTypes.User]) },
        { id: VonEmployeeTypes.Conversion, name: t(VonEmployeeTypesText[VonEmployeeTypes.Conversion]) },
        { id: VonEmployeeTypes.BankruptcyTrustee, name: t(VonEmployeeTypesText[VonEmployeeTypes.BankruptcyTrustee]) }
    ]

    const onEmployeeTypeChange = (value) => {
        field('type').onChange(value);

        if (value === VonEmployeeTypes.BankruptcyTrustee.toString()) {
            field('isAdmin').onChange(true);
            field('isPrimaryContact').onChange(true);
        } else {
            field('isAdmin').onChange(false);
            field('isPrimaryContact').onChange(false);
        }
    };

    return <StepperModal title={t('vonaccountscontainer.createnewuser')} onClose={closeModal} isLoading={false} isStepLoading={stepLoading} stepHeaderType={StepHeaderType.NONE} modalSize={ModalSize.LARGE}>
        <Step>
            <StepBody>
                <FormInput label={t('common.email')} value={form.data['email']} {...field('email')} />
            </StepBody>
            <StandardStepFooter onCancel={closeModal} disabled={!form.valid} onNextClick={() => dispatch(employeesActions.checkVonEmployee(form))} />
        </Step>
        <Step>
            <StepBody>
                {form.data.userAlreadyExists && <div>
                    <p>The user {form.data.email} is already in use in another company. The first and last name can therefore not be edited.</p>
                </div>}
                <fieldset className="d-grid col-12 gap-12">
                    <FormInput label={t('common.email')} value={form.data['email']} {...field('email')} disabled={true} />
                    <FormInput label={t('common.firstname')} value={form.data['firstName']} {...field('firstName')} disabled={form.data.userAlreadyExists} />
                    <FormInput label={t('common.lastname')} value={form.data['lastName']}  {...field('lastName')} disabled={form.data.userAlreadyExists} />
                    <Dropdown label={t('vonaccountformcontainer.typeofuser')}
                              value={form.data['type'] ? form.data['type'] : null}
                              options={employeeTypes}
                              onChange={onEmployeeTypeChange}
                              placeholder={t('vonaccountscontainer.selectTypeOfUser')} />
                    {form.data.type == VonEmployeeTypes.Conversion && <DateTimeInput label={t('')} dateFormat={"YYYY-MM"} showTime={false} {...field('validUntil')} />}
                </fieldset>
            </StepBody>
            <StandardStepFooter onCancel={closeModal} onPreviousClick={() => dispatch(formActions.updateFormValidationRules(form.id, formValidationRules.VonEmployeeCheckForm))}>
                <Button disabled={!form.valid} option={ButtonOption.PRIMARY} onClick={onSubmit}>Spara</Button>
            </StandardStepFooter>
        </Step>
    </StepperModal>
}

export default CreateVonEmployeeModal;